import React from "react"
import { Col, FormGroup, InputGroup, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import 'react-image-lightbox/style.css'
import PriceUtils from "../../../helpers/PriceUtils"
import IconCheckbox from '../../../assets/images/icon-checkbox.png'
import IconCheckboxActive from '../../../assets/images/icon-checkbox-active.png'


const ProductViewDetail = (props: any) => {
    const { title, data, dataActive, imgs, setData, type, onlyView, handleChangeInput, category, brand, origin } = props

    return (
        <PageBody>
            {title && <div className="nutri-title mb-3">{title}</div>}
            <Row>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>SKU</Label>
                        <InputGroup>
                            {dataActive?.sku  || '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>SKU ERP</Label>
                        <InputGroup>
                            {dataActive?.erp_sku  || '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Mã vạch</Label>
                        <InputGroup>
                            {dataActive?.barcode  || '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Chiều dài / Chiều rộng / Chiều cao</Label>
                        <InputGroup>
                            {dataActive?.longs ? PriceUtils.format(dataActive?.longs, '') : '---'} / {dataActive?.width ? PriceUtils.format(dataActive?.width, '') : '---'} / {dataActive?.height ?PriceUtils.format(dataActive?.height, '') : '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Khối lượng (g)</Label>
                        <InputGroup>
                            {dataActive?.weight  || '---'} (g)
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Đơn vị xuất kho</Label>
                        <InputGroup>
                            {dataActive?.unit_name || data?.minimum_unit  || '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>
            <div className="nutri-title mb-3">Giá bán</div>
            <Row>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Giá nhập</Label>
                        <InputGroup>
                            {dataActive?.price_import ? PriceUtils.format(dataActive?.price_import) : '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Giá bán lẻ</Label>
                        <InputGroup>
                            {dataActive?.price ? PriceUtils.format(dataActive?.price) : '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Giá bán buôn</Label>
                        <InputGroup>
                            {dataActive?.price_wholesale ? PriceUtils.format(dataActive?.price_wholesale) : '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className={type != 'view' ? 'nutri-form placeholder-right1' : 'nutri-form'}>
                        <div className="d-flex align-items-center">
                            <Row style={{width:'100%'}}>
                                <Col xl={12}>
                                    <div className="nutri-checkbox" onClick={() => type =='view' ? {} : handleChangeInput({target:{ name: "vat_enable" , value: data?.vat_enable ? false: true }})}>
                                        <div className="icon">
                                            {data?.vat_enable ?
                                            <img src={IconCheckboxActive} alt="icon" />:    
                                            <img src={IconCheckbox} alt="icon" />  
                                            }
                                        </div>
                                        <div className="label">Áp dụng thuế</div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {data?.vat_enable ?
                        <>
                            <Label>Giá trị thuế</Label>
                            <InputGroup>
                                {dataActive?.vat ? PriceUtils.format(dataActive?.vat, '%') : '---'}
                            </InputGroup>
                        </>:''}
                    </FormGroup>
                </Col>
            </Row>
        </PageBody>
    )
}

export default ProductViewDetail